// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"ba2ab137","150":"6316193f","210":"3b3063e0","263":"ee58e4e8","488":"bab1e1b1","814":"f41c33cf","871":"4bfb8c63","887":"cc016eeb"}[chunkId] + ".chunk.js";
};